export default __webpack_public_path__ + "static/apple-podcasts-dark-0ca11fbdf02d9fff75374e8a8ace8dac.svg";